interface QuestionOption {
  value: number;
  label: string;
  key?: string;
}

interface QuestionData {
  title: string;
  description?: string;
  type: 'radio' | 'checkbox' | 'number';
  options?: QuestionOption[];
}

export const getQuestionData = (questionKey: string): QuestionData | null => {
  const questionMap: Record<string, QuestionData> = {
    'Q02': {
      title: 'Vykonával/a jste v posledních 12 měsících dobrovolnickou činnost alespoň 1 hodinu?',
      type: 'radio',
      options: [
        { value: 1, label: 'Ano' },
        { value: 2, label: 'Ne' },
        { value: 3, label: 'Nevzpomínám si' }
      ]
    },
    'Q03': {
      title: 'A vykonával/a jste v posledních 4 týdnech dobrovolnickou činnost alespoň 1 hodinu?',
      type: 'radio',
      options: [
        { value: 1, label: 'Ano' },
        { value: 2, label: 'Ne' },
        { value: 3, label: 'Nevzpomínám si' }
      ]
    },
    'Q04': {
      title: 'Označte, prosím, níže všechny formy dobrovolnictví a bezplatné pomoci, které jste v posledních 4 týdnech vykonával/a.',
      type: 'checkbox',
      options: [
        { value: 1, label: 'Dobrovolnictví organizované organizací (např. spolek, oddíl, obec, nezisková organizace, církev)', key: 'Q04_A' },
        { value: 2, label: 'Dobrovolnictví organizované neformální skupinou, společenstvím (např. dobrovolnictví pro komunitní a sousedské akce)', key: 'Q04_B' },
        { value: 3, label: 'Přímá pomoc – osobní pomoc jinému člověku nebo péče o přírodu či zvířata z vlastní iniciativy', key: 'Q04_C' },
        { value: 4, label: 'Nic z výše uvedeného', key: 'Q04_D' }
      ]
    },
    'Q10': {
      title: 'Kolik hodin jste celkem strávil/a v posledních 4 týdnech dobrovolnickou činností?',
      type: 'number'
    },
    'Q12': {
      title: 'Když uvážíte všechny své dobrovolnické činnosti za posledních 12 měsíců, jak často jste takto zpravidla pomáhal/a?',
      type: 'radio',
      options: [
        { value: 1, label: 'Téměř denně' },
        { value: 2, label: '(Téměř) každý týden' },
        { value: 3, label: 'Vícekrát do měsíce, ale ne každý týden' },
        { value: 4, label: 'Přibližně jednou za měsíc' },
        { value: 5, label: 'Přibližně jednou za tři měsíce' },
        { value: 6, label: 'Jen jednou nebo dvakrát' }
      ]
    },
    'D01_new': {
      title: 'Daroval/a jste v posledních 12 měsících finanční dar/y na dobročinné účely?',
      type: 'radio',
      options: [
        { value: 1, label: 'Ano' },
        { value: 2, label: 'Ne' },
        { value: 3, label: 'Nevzpomínám si' }
      ]
    },
    'D07': {
      title: 'A daroval/a jste za poslední 4 týdny finanční dar/y na dobročinné účely?',
      type: 'radio',
      options: [
        { value: 1, label: 'Ano' },
        { value: 2, label: 'Ne' },
        { value: 3, label: 'Nevzpomínám si' }
      ]
    },
    'D13': {
      title: 'Když uvážíte všechno své dárcovství na dobročinné účely za posledních 12 měsíců, která z následujících možností Vás nejlépe vystihuje?',
      type: 'radio',
      options: [
        { value: 1, label: 'Dávám (téměř) jen pravidelné dary jako výraz dlouhodobé podpory.' },
        { value: 2, label: 'Dávám převážně pravidelné dary, ale trochu daruji i jednorázově / spontánně.' },
        { value: 3, label: 'Dávám asi stejně pravidelné i jednorázové dary.' },
        { value: 4, label: 'Dávám převážně jednorázové dary, ale mám i nějaké pravidelné.' },
        { value: 5, label: 'Dávám (téměř) jen jednorázové / spontánní dary.' }
      ]
    },
    'D16': {
      title: 'Daroval/a jste krev v posledních 12 měsících?',
      description: 'Pozn.: Dárcovství krve se nepočítá jako dobrovolnictví pro předchozí otázky.',
      type: 'radio',
      options: [
        { value: 1, label: 'Ano' },
        { value: 2, label: 'Ne' }
      ]
    },
    'D17': {
      title: 'Daroval/a jste někdy za posledních 12 měsíců nějaký nefinanční dar na dobročinné účely?',
      type: 'checkbox',
      options: [
        { value: 1, label: 'Oblečení', key: 'D17_A' },
        { value: 2, label: 'Potraviny', key: 'D17_B' },
        { value: 3, label: 'Elektroniku', key: 'D17_C' },
        { value: 4, label: 'Možnost využívat bezplatně nějaký prostor nebo drahou věc', key: 'D17_D' },
        { value: 5, label: 'Něco jiného', key: 'D17_E' },
        { value: 6, label: 'Za posledních 12 měsíců nic (nebo si nevzpomínám)', key: 'D17_F' }
      ]
    },
    'P01_A': {
      title: 'Do jaké míry souhlasíte, nebo nesouhlasíte s následujícím výrokem?',
      description: 'Je morální povinností těch, kteří mají hodně, přispívat těm, kteří mají méně.',
      type: 'radio',
      options: [
        { value: 1, label: 'Určitě souhlasím' },
        { value: 2, label: 'Spíše souhlasím' },
        { value: 3, label: 'Tak napůl' },
        { value: 4, label: 'Spíše nesouhlasím' },
        { value: 5, label: 'Určitě nesouhlasím' }
      ]
    },
    'P01_B': {
      title: 'Do jaké míry souhlasíte, nebo nesouhlasíte s následujícím výrokem?',
      description: 'I lidé, kteří mají jen průměrné příjmy, by měli přispívat na charitu.',
      type: 'radio',
      options: [
        { value: 1, label: 'Určitě souhlasím' },
        { value: 2, label: 'Spíše souhlasím' },
        { value: 3, label: 'Tak napůl' },
        { value: 4, label: 'Spíše nesouhlasím' },
        { value: 5, label: 'Určitě nesouhlasím' }
      ]
    },
    'P01_C': {
      title: 'Do jaké míry souhlasíte, nebo nesouhlasíte s následujícím výrokem?',
      description: 'Pomáhat ostatním, i když to může znamenat nějaké komplikace, je pro mě důležitou hodnotou.',
      type: 'radio',
      options: [
        { value: 1, label: 'Určitě souhlasím' },
        { value: 2, label: 'Spíše souhlasím' },
        { value: 3, label: 'Tak napůl' },
        { value: 4, label: 'Spíše nesouhlasím' },
        { value: 5, label: 'Určitě nesouhlasím' }
      ]
    },
    'P01_D': {
      title: 'Do jaké míry souhlasíte, nebo nesouhlasíte s následujícím výrokem?',
      description: 'Lidé by si měli být ochotni vzájemně pomáhat, i když z toho nemají přímý prospěch.',
      type: 'radio',
      options: [
        { value: 1, label: 'Určitě souhlasím' },
        { value: 2, label: 'Spíše souhlasím' },
        { value: 3, label: 'Tak napůl' },
        { value: 4, label: 'Spíše nesouhlasím' },
        { value: 5, label: 'Určitě nesouhlasím' }
      ]
    },
    'P01_E': {
      title: 'Do jaké míry souhlasíte, nebo nesouhlasíte s následujícím výrokem?',
      description: 'Solidarita s chudými by měla být prioritou státu, i když to může znamenat zpomalení ekonomického růstu.',
      type: 'radio',
      options: [
        { value: 1, label: 'Určitě souhlasím' },
        { value: 2, label: 'Spíše souhlasím' },
        { value: 3, label: 'Tak napůl' },
        { value: 4, label: 'Spíše nesouhlasím' },
        { value: 5, label: 'Určitě nesouhlasím' }
      ]
    },
    'P01_F': {
      title: 'Do jaké míry souhlasíte, nebo nesouhlasíte s následujícím výrokem?',
      description: 'Úroveň společnosti se pozná podle toho, jak se dokáže postarat o ty nejslabší.',
      type: 'radio',
      options: [
        { value: 1, label: 'Určitě souhlasím' },
        { value: 2, label: 'Spíše souhlasím' },
        { value: 3, label: 'Tak napůl' },
        { value: 4, label: 'Spíše nesouhlasím' },
        { value: 5, label: 'Určitě nesouhlasím' }
      ]
    },
    'P01_G': {
      title: 'Do jaké míry souhlasíte, nebo nesouhlasíte s následujícím výrokem?',
      description: 'Stát by měl usilovat o příznivé podmínky pro fungování neziskových a charitativních organizací.',
      type: 'radio',
      options: [
        { value: 1, label: 'Určitě souhlasím' },
        { value: 2, label: 'Spíše souhlasím' },
        { value: 3, label: 'Tak napůl' },
        { value: 4, label: 'Spíše nesouhlasím' },
        { value: 5, label: 'Určitě nesouhlasím' }
      ]
    }
  };

  return questionMap[questionKey] || null;
};